/*
 * @Author: 张韶杰
 * @Date: 2024-10-31 11:14:34
 * @LastEditors: 张韶杰
 * @LastEditTime: 2024-11-01 12:02:34
 * @FilePath: \ysz_web_international-h5\src\store\modules\base.js
 * @Description: 
 * 
 */

import storage from 'store'
import store from '@/store'
import { getUserInfo } from '@/api/common'
import router from '@/router'
const base = {
  state: {
    anchorName: {},
    activeNavName:{},
  },

  mutations: {
    SET_ANCHOR_NAME: (state, anchor) => {
      state.anchorName = anchor
    },
    SET_ACTIVE_NAV_NAME:(state, name) => {
      console.log(name,'44444444name')
      state.activeNavName = name
    }
  },

  actions: {
    // 设置锚点名称
     setAcchorName ({ commit }, anchor) {
      commit('SET_ANCHOR_NAME', anchor)
    },
    //导航高亮
    setActiveNavName({ commit }, anchor) {
      console.log(anchor,44444444)
      commit('SET_ACTIVE_NAV_NAME', anchor)
    }
  }
}

export default base